import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode } from "vue"
import _imports_0 from '@/static/icons/WOMAN_IN_BLUE_HOME.jpeg'
import _imports_1 from '@/static/icons/SMALL_DOWN_ARROW.svg'


const _hoisted_1 = {
  key: 0,
  class: "home"
}
const _hoisted_2 = {
  id: "start",
  class: "home__introduction-wrapper"
}
const _hoisted_3 = { class: "home__introduction-content" }
const _hoisted_4 = { class: "home__intro-header" }
const _hoisted_5 = { class: "home__content-wrapper" }
const _hoisted_6 = { class: "home__explore-card-wrapper" }
const _hoisted_7 = { class: "home__gallery-list" }
const _hoisted_8 = { class: "home__feedback-wrapper" }
const _hoisted_9 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RenderContent = _resolveComponent("RenderContent")!
  const _component_CollectionCard = _resolveComponent("CollectionCard")!

  return (_ctx.home)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "home__landing-wrapper" }, [
          _createElementVNode("div", { class: "home__landing-section" }, [
            _createElementVNode("img", {
              class: "home__painting",
              src: _imports_0,
              alt: "home page background"
            }),
            _createElementVNode("a", {
              id: "start-button",
              href: "#explore",
              class: "home__start-button",
              role: "button"
            }, [
              _createElementVNode("span", { class: "home__start" }, "Start")
            ]),
            _createElementVNode("span", { class: "home__whats-this" }, "What's this all about")
          ]),
          _createElementVNode("div", { class: "home__arrow-cta" }, [
            _createElementVNode("img", {
              class: "home__arrow",
              src: _imports_1,
              alt: "arrow that points down"
            })
          ])
        ], -1)),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.home.heading), 1),
            _createElementVNode("div", _hoisted_5, [
              (_ctx.panels)
                ? (_openBlock(), _createBlock(_component_RenderContent, {
                    key: 0,
                    panels: _ctx.panels
                  }, null, 8, ["panels"]))
                : _createCommentVNode("", true)
            ]),
            _cache[0] || (_cache[0] = _createElementVNode("div", { id: "explore" }, null, -1))
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _cache[1] || (_cache[1] = _createElementVNode("h1", { class: "home__explore-dt" }, "Explore", -1)),
          _cache[2] || (_cache[2] = _createElementVNode("div", { class: "home__explore-heading-wrapper" }, [
            _createElementVNode("h1", { class: "home__explore" }, "Explore")
          ], -1)),
          _createElementVNode("div", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.collections, (collection, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "home__gallery-item-wrapper"
              }, [
                _createVNode(_component_CollectionCard, {
                  collection: collection,
                  totalGalleries: _ctx.tagCounts[collection.collectionTag]
                }, null, 8, ["collection", "totalGalleries"])
              ]))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("a", {
            class: "home__feedback-link",
            target: "_blank",
            href: _ctx.GENERAL_FEEDBACK_URL
          }, "Give Feedback", 8, _hoisted_9)
        ])
      ]))
    : _createCommentVNode("", true)
}